export default {
      id: "graph-nunavik-usage",
      viewBox: "0 0 170 230",
      url: __webpack_public_path__ + "svg/sprite.svg#graph-nunavik",
      toString: function () {
        return this.url;
      }
    }